var map = {
	"./icon-bonus-1.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/bonus/icon-bonus-1.svg",
	"./icon-bonus-2.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/bonus/icon-bonus-2.svg",
	"./icon-bonus-3.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/bonus/icon-bonus-3.svg",
	"./icon-bonus-4.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/bonus/icon-bonus-4.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/svg/bonus sync recursive !!./node_modules/html-loader/dist/cjs.js! ^\\.\\/icon\\-bonus\\-.*\\.svg$";